import {
  message_input_styles_default
} from "./chunk.3GKOM3SM.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/message-input/message-input.ts
import { t as t2 } from "i18next";
var FadvMessageInput = class extends s {
  constructor() {
    super(...arguments);
    this.label = t2("components:messageInput.label");
    this.buttonDisabled = true;
  }
  handleClick() {
    if (!this.inputElement.value)
      return;
    const event = emit(this, "fadv-message-submitted", { detail: { message: this.inputElement.value } });
    if (event.defaultPrevented) {
      return;
    }
    this.inputElement.value = "";
    this.buttonDisabled = true;
  }
  handleKeyDown(event) {
    if (event.key !== "Enter")
      return;
    this.handleClick();
  }
  handleInputChange() {
    this.buttonDisabled = !this.inputElement.value;
  }
  render() {
    return $`<sl-input part="base" class="message-input" @keydown=${this.handleKeyDown} placeholder=${l(this.placeholder)} minlength=${l(this.minlength)} maxlength=${l(this.maxlength)} @sl-input=${this.handleInputChange} ><sl-icon-button ?disabled=${this.buttonDisabled} slot="suffix" @click=${this.handleClick} name="fa-paper-plane" library="solid" label=${this.label} ></sl-icon-button></sl-input>`;
  }
};
FadvMessageInput.styles = message_input_styles_default;
__decorateClass([
  i("sl-input")
], FadvMessageInput.prototype, "inputElement", 2);
__decorateClass([
  e({ reflect: true })
], FadvMessageInput.prototype, "placeholder", 2);
__decorateClass([
  e({ type: Number })
], FadvMessageInput.prototype, "minlength", 2);
__decorateClass([
  e({ type: Number })
], FadvMessageInput.prototype, "maxlength", 2);
__decorateClass([
  e()
], FadvMessageInput.prototype, "label", 2);
__decorateClass([
  t()
], FadvMessageInput.prototype, "buttonDisabled", 2);
FadvMessageInput = __decorateClass([
  n("fadv-message-input")
], FadvMessageInput);

export {
  FadvMessageInput
};
